import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { DoctorListSer } from './Services/DoctorListSer';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
const DoctorProfile= () => {
    useEffect(() => {
             const scriptUrls = [
               'assets/js/jquery.min.js',
               'assets/js/bootstrap.bundle.min.js',
               'assets/js/moment.min.js',
               'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
               'assets/vendor/overlay-scroll/custom-scrollbar.js',
               'assets/vendor/daterange/daterange.js',
               'assets/vendor/daterange/custom-daterange.js',
               'assets/vendor/rating/raty.js',
               'assets/vendor/rating/raty-custom.js',
               'assets/js/custom.js'
             ];
         
             let isCancelled = false;
         
             // Load scripts sequentially
             const loadScriptsSequentially = async () => {
               for (const url of scriptUrls) {
                 if (isCancelled) break;
         
                 await new Promise((resolve, reject) => {
                   const script = document.createElement('script');
                   script.src = url;
                   script.onload = resolve;
                   script.onerror = reject;
                   document.body.appendChild(script);
                 });
               }
             };
         
             loadScriptsSequentially();
         
             return () => {
               isCancelled = true;
               // Optionally remove scripts if needed
             };
           }, []);
    const navigator = useNavigate();
    const handleUpdateClick = (e,id) => {
        e.preventDefault();
         // Navigate to /page2 and pass the value
         navigator('/update-doctors', { state: { uata: id } });
         window.location.reload();
       };
       const handleViewClick = (e,id) => {
        e.preventDefault();
         // Navigate to /page2 and pass the value
         navigator('/doctor-profile', { state: { uata: id } });
         window.location.reload();
       };
       
    
     
    /* const dummyData =[
        {
            "id":1,
            "users":"Gautam Kumar",
            "title":"Dam it",
            "author":"Rest Api",
            "isbn":"isbn34546",
            "description":"This is really good",
            "backCover":"file1.jpg"
        }
    ] */
        const [department, setDepartment] = useState([]);
        const srcImg="http://localhost:8080/Images/";
        useEffect(() =>{
            const REST_API_BASE_URL = `http://localhost:8080/api/listBooksByUsers`;
            const listDoctorUser =() => axios.get(REST_API_BASE_URL);
            listDoctorUser().then((response) => {
                setDepartment(response.data);
            }).catch(error =>{
                console.error(error);
            })
        } , [])
        
        return(
           
<div>
  {/* App hero header starts */}
  <div className="app-hero-header d-flex align-items-center">
    {/* Breadcrumb starts */}
    <ol className="breadcrumb">
      <li className="breadcrumb-item">
        <a href="index-2.html">
          <i className="ri-home-3-line" />
        </a>
      </li>
      <li className="breadcrumb-item text-primary" aria-current="page">
        Doctors Profile
      </li>
    </ol>
    {/* Breadcrumb ends */}
    {/* Sales stats starts */}
    <div className="ms-auto d-lg-flex d-none flex-row">
      <div className="input-group">
        <span className="input-group-text bg-primary-lighten">
          <i className="ri-calendar-2-line text-primary" />
        </span>
        <input type="text" id="abc" className="form-control custom-daterange" />
      </div>
    </div>
    {/* Sales stats ends */}
  </div>
  {/* App Hero header ends */}
  {/* App body starts */}
  <div className="app-body">
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-sm-12">
        <div className="card mb-4">
          <div className="card-body">
            {/* Row starts */}
            <div className="row gx-4">
              <div className="col-xxl-6 col-sm-12 col-12">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <img src="assets/images/doctors/14.jpg" className="mw-240 rounded-2 border border-primary border-2" alt="Dentist Dashboard" />
                  <div className>
                    <span className="badge bg-primary-subtle text-primary"><i className="ri-circle-fill me-1" />Available</span>
                    <p className="mb-1 mt-2">Good Morning,</p>
                    <p className="fs-5 fw-semibold">Dr. Lorna Simmons</p>
                    <p className="mb-1">BDS, MDS - General Surgery, General Physician</p>
                    <p className="mb-1">Speaks: English, and Spanish</p>
                    <p className="mb-1">Location: 9 E 2nd St, New York, NY 10003, USA</p>
                  </div>
                </div>
              </div>
              <div className="col-xxl-6 col-sm-12 col-12">
                <div className="h-100 border-start border-sm-none">
                  <div className="ps-4">
                    <div className="d-flex justify-content-between">
                      <div className="d-flex flex-row flex-wrap gap-2">
                        <div className="d-flex align-items-center">
                          <div className="icon-box sm bg-primary-subtle rounded-5 me-2">
                            <i className="ri-chat-1-line fs-5 text-primary" />
                          </div>
                          <div>
                            Online Consultation Available
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="icon-box sm bg-primary-subtle rounded-5 me-2">
                            <i className="ri-building-2-line fs-5 text-primary" />
                          </div>
                          <div>
                            Apollo Medicals &amp; Hospital
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="icon-box sm bg-primary-subtle rounded-5 me-2">
                            <i className="ri-account-circle-line fs-5 text-primary" />
                          </div>
                          <div>
                            <span className="fw-semibold text-primary">96%</span> Recommended
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-row gap-2">
                        <a href="javascript:void(0)" className="icon-box xs icon-box-hover rounded-5">
                          <i className="ri-star-line fs-6 text-primary" />
                        </a>
                        <a href="javascript:void(0)" className="icon-box xs icon-box-hover rounded-5">
                          <i className="ri-link-m fs-6 text-primary" />
                        </a>
                        <a href="javascript:void(0)" className="icon-box xs icon-box-hover rounded-5">
                          <i className="ri-share-line fs-6 text-primary" />
                        </a>
                      </div>
                    </div>
                    <div className="d-flex mt-3">
                      <div className="rating-stars">
                        <div className="readonly5" />
                      </div>
                      <span className="fw-bold fs-6 me-1">3690</span> Reviews
                    </div>
                    <div className="d-flex gap-1 mt-3">
                      <a href="#" className="btn btn-sm btn-primary"><i className="ri-chat-1-line me-2" />Chat</a>
                      <a href="#" className="btn btn-sm btn-primary"><i className="ri-headphone-line me-2" />Audio
                        Call</a>
                      <a href="#" className="btn btn-sm btn-primary"><i className="ri-vidicon-line me-2" />Video
                        Call</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Row ends */}
          </div>
          <div className="card-footer border-top">
            <div className="d-flex align-items-center flex-row flex-wrap gap-3">
              <div className="d-flex align-items-center">
                <div className="icon-box sm icon-box-hover rounded-5 me-2">
                    <a href="/doc-appointment" >
                  <i className="ri-building-2-line fs-5 text-primary"/>
                  </a>
                </div>
                <div>
                  9 appointments today
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="icon-box sm icon-box-hover rounded-5 me-2">
                  <i className="ri-chat-1-line fs-5 text-primary" />
                </div>
                <div>
                  18 years in practice
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="icon-box sm icon-box-hover rounded-5 me-2">
                  <i className="ri-account-circle-line fs-5 text-primary" />
                </div>
                <div>
                  <span className="fw-bold text-primary">$150</span> consulting fee
                </div>
              </div>
              <div className="ms-auto">
                <a href="/book-appointment" className="btn btn-primary">
                  Book Appointment
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Row ends */}
    {/* Row starts */}
    <div className="row gx-4">
      <div className="col-xl-8 col-sm-12">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-sm-12">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title">Bio</h5>
              </div>
              <div className="card-body pt-0">
                <p>
                  Dr. Rachell Linda is an eminent Endocrinologist associated with med hospitals who is
                  specially
                  trained to diagnose diseases related to glands. She specialises in treating people
                  who suffer from hormonal imbalances, typically from glands in the endocrine system. The most
                  common conditions treated by Dr. Linda are Diabetes, Metabolic disorders, Lack of
                  growth, Osteoporosis, Thyroid diseases, Cancers of the endocrine glands, Over- or
                  under-production of hormones, Cholesterol disorders, Hypertension and Infertility. Also
                  available for consultation at Med hospital. Dr. Linda's approach lies in understanding
                  patients diseases and the procedure recommended along with care.</p>
                <div className>
                  <h6>Speciality</h6>
                  <div className="d-flex flex-wrap gap-2">
                    <span className="border border-primary p-2 lh-1 text-body rounded-1">Diabetes</span>
                    <span className="border border-primary p-2 lh-1 text-body rounded-1">Thyroid</span>
                    <span className="border border-primary p-2 lh-1 text-body rounded-1">Osteoporosis</span>
                    <span className="border border-primary p-2 lh-1 text-body rounded-1">Surgeon</span>
                    <span className="border border-primary p-2 lh-1 text-body rounded-1">General</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title">Reviews</h5>
              </div>
              <div className="card-body">
                {/* Reviews starts */}
                <div className="d-grid gap-5">
                  <div className="d-flex">
                    <img src="assets/images/patient1.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <span className="badge border border-primary text-primary mb-3">Excellent</span>
                      <h6>Wendi Combs</h6>
                      <p className="mb-2">I am consulting with her for last 10 years and she is really good in
                        thyroid. Her experience has greatest strength. By looking at the report she will
                        diagnosis the problem and listen to us. We might think she is in a hurry to complete
                        the
                        patient but her experience makes her 100%.</p>
                      <p><i className="ri-thumb-up-line" /> I recommend the doctor.</p>
                      <div className="rating-stars">
                        <div className="readonly5" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <img src="assets/images/patient2.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <span className="badge border border-primary text-primary mb-3">Excellent</span>
                      <h6>Nick Morrow</h6>
                      <p className="mb-2">Dr.Rachell is my physician from past four years. Till now, whatever
                        treatment and advice she has given me is of the best kind. I am extremely satisfied
                        with
                        it. There may be about 10 minutes of waiting period before consultation. The hospital
                        and staff are good as well.</p>
                      <p><i className="ri-thumb-up-line" /> I recommend the doctor.</p>
                      <div className="rating-stars">
                        <div className="readonly5" />
                      </div>
                    </div>
                  </div>
                  <div className="d-flex">
                    <img src="assets/images/patient3.png" className="img-4x rounded-2" alt="Medical Admin Template" />
                    <div className="ms-3">
                      <span className="badge border border-danger text-danger mb-3">Bad</span>
                      <h6>Carole Dodson</h6>
                      <p className="mb-2">Its a not recommerded example. Its a not recommerded example. Its a not
                        recommerded example. Its a not recommerded example.
                      </p>
                      <p><i className="ri-thumb-down-line" /> I do not recommend the doctor.</p>
                      <div className="rating-stars">
                        <div className="readonly2" />
                      </div>
                    </div>
                  </div>
                  <div className="d-grid">
                    <button className="btn btn-primary">Load More</button>
                  </div>
                </div>
                {/* Reviews ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      <div className="col-xl-4 col-sm-12">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12 col-sm-6">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title">Avalibility</h5>
              </div>
              <div className="card-body pt-0">
                <ul className="list-group mb-2">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Monday
                    <span className="badge border border-success text-success">9:AM - 2:PM</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Tuesday
                    <span className="badge border border-success text-success">9:AM - 2:PM</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Wednesday
                    <span className="badge border border-success text-success">9:AM - 2:PM</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Thursday
                    <span className="badge border border-success text-success">9:AM - 2:PM</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Friday
                    <span className="badge border border-success text-success">9:AM - 2:PM</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Saturday
                    <span className="badge border border-success text-success">9:AM - 2:PM</span>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    Sunday
                    <span className="badge border border-danger text-danger">Holiday</span>
                  </li>
                </ul>
                <a href="/book-appointment" className="btn btn-primary">
                  Book Appointment
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-12 col-sm-6">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title">Awards</h5>
              </div>
              <div className="card-body">
                <div>
                  <div id="carouselAwards" className="carousel carousel-dark slide" data-bs-ride="carousel">
                    <div className="carousel-indicators">
                      <button type="button" data-bs-target="#carouselAwards" data-bs-slide-to={0} className="active" aria-current="true" aria-label="Slide 1" />
                      <button type="button" data-bs-target="#carouselAwards" data-bs-slide-to={1} aria-label="Slide 2" />
                      <button type="button" data-bs-target="#carouselAwards" data-bs-slide-to={2} aria-label="Slide 3" />
                    </div>
                    <div className="carousel-inner text-center">
                      <div className="carousel-item active" data-bs-interval={10000}>
                        <img src="assets/images/award/award.svg" className="img-300" alt="Medical Templates" />
                      </div>
                      <div className="carousel-item" data-bs-interval={5000}>
                        <img src="assets/images/award/award1.svg" className="img-300" alt="Medical Templates" />
                      </div>
                      <div className="carousel-item" data-bs-interval={2500}>
                        <img src="assets/images/award/award2.svg" className="img-300" alt="Medical Templates" />
                      </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselAwards" data-bs-slide="prev">
                      <span className="carousel-control-prev-icon" aria-hidden="true" />
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselAwards" data-bs-slide="next">
                      <span className="carousel-control-next-icon" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="text-center">
                    <h1 className="text-primary">3</h1>
                    Awards received in 2024.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
    </div>
    {/* Row ends */}
  </div>
  {/* App body ends */}
</div>

        );
        
}

export default DoctorProfile;






